import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LabelGroup from 'LuxKit/Label/LabelGroup'
import BodyText from 'LuxKit/Typography/BodyText'
import Caption from 'LuxKit/Typography/Caption'
import Plural from 'components/utils/Formatters/Plural'
import { useAppSelector } from 'hooks/reduxHooks'
import getLoyaltyDisplayTier from 'loyalty/selectors/getLoyaltyDisplayTier'
import getLoyaltyTierDisplayName from 'loyalty/selectors/getLoyaltyTierDisplayName'
import React, { PropsWithChildren, ReactNode } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  grid-area: banner;
`

type Props = {
  /**
   * positive integer
   */
  packageNumber?: number
  tagLineLabel?: ReactNode
  stayPayRateTier?: App.StayPayTier
} & ({
  roomPackage?: App.HotelPackage
  selectedLoyaltyTargetUpgradePackage?: App.Package
  promotion?: undefined
} | {
  roomPackage?: undefined
  selectedLoyaltyTargetUpgradePackage?: undefined
  promotion?: App.BedbankPromotion
})

function AccommodationSameRoomOptionTileBanner(props: PropsWithChildren<Props>) {
  const {
    children,
    packageNumber,
    tagLineLabel,
    roomPackage,
    promotion,
    stayPayRateTier,
    selectedLoyaltyTargetUpgradePackage,
  } = props

  const name = roomPackage?.name ?? promotion?.name
  const targetUpgradeName = selectedLoyaltyTargetUpgradePackage?.name
  const displayTier = useAppSelector(getLoyaltyDisplayTier)

  return <Container>
    <VerticalSpacer gap={4}>
      <VerticalSpacer gap={8}>
        {!!packageNumber && <Caption variant="large">
          Package option {packageNumber}
          {!!targetUpgradeName && <> | <b>{getLoyaltyTierDisplayName(displayTier)} member upgrade</b></>}
        </Caption>}
        {!!tagLineLabel && <LabelGroup>{tagLineLabel}</LabelGroup>}
      </VerticalSpacer>
      {!!targetUpgradeName && <BodyText variant="large" weight="bold">
        Upgraded to {targetUpgradeName}
      </BodyText>}
      {!!name && <BodyText
        variant="large"
        weight="bold"
        colour={selectedLoyaltyTargetUpgradePackage ? 'neutral-four' : 'neutral-one'}
        strikeThrough={!!selectedLoyaltyTargetUpgradePackage}
      >
        {name}
        {stayPayRateTier && <>, <Plural singular="night free" count={stayPayRateTier.freeNights} withCount /></>}
      </BodyText>}
    </VerticalSpacer>
    {children}
  </Container>
}

export default AccommodationSameRoomOptionTileBanner
